"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authenticationLink = exports.retryLink = void 0;
const context_1 = require("@apollo/client/link/context");
const retry_1 = require("@apollo/client/link/retry");
const fdr_lib_ident_auth_config_1 = require("@hotelplan/fdr.lib.ident.auth-config");
let refreshedAccessToken;
const getNewAccessToken = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(fdr_lib_ident_auth_config_1.SSR_TOKENS_ENDPOINT_PATH);
    const { accessToken } = yield response.json();
    return accessToken;
});
const handleRetry = (error, operation) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    let requiresRetry = false;
    if (((_a = operation.getContext().response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
        try {
            const accessToken = yield getNewAccessToken();
            requiresRetry = true;
            const oldHeaders = operation.getContext().headers;
            refreshedAccessToken = accessToken;
            operation.setContext({
                headers: Object.assign(Object.assign({}, oldHeaders), { authorization: `Bearer ${accessToken}` }),
            });
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.log(`[Refresh token error]: ${error}`);
        }
    }
    return requiresRetry;
});
exports.retryLink = new retry_1.RetryLink({
    delay: { initial: 300, max: Infinity, jitter: false },
    attempts: {
        max: 3,
        retryIf: (error, operation) => handleRetry(error, operation),
    },
});
const authenticationLink = (getAccessToken) => (0, context_1.setContext)((_, { headers }) => __awaiter(void 0, void 0, void 0, function* () {
    const token = getAccessToken === null || getAccessToken === void 0 ? void 0 : getAccessToken();
    return {
        headers: Object.assign(Object.assign({}, headers), { Authorization: token
                ? `Bearer ${refreshedAccessToken ? refreshedAccessToken : token}`
                : '' }),
    };
}));
exports.authenticationLink = authenticationLink;
//# sourceMappingURL=authLinks.js.map